import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DisplayableValue from './DisplayableValue';

interface TextFieldProps {
  isEditable: boolean;
  value: string;
  onItemUpdated: Function;
}

const TextField = ({ isEditable, value, onItemUpdated }: TextFieldProps) => {
  const [editMode, setEditMode] = useState(false);
  const { t } = useTranslation();

  if (!isEditable) {
    return <span>{`${value}%`}</span>;
  }

  const handleDisplayClick = () => {
    if (isEditable) {
      setEditMode(true);
    }
  };

  const onSave = (newValue: string) => onItemUpdated(value, newValue);

  const onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.KeyboardEvent<HTMLInputElement>,
  ) => {
    const inputValue = (e.target as HTMLInputElement).value;
    if (inputValue === value) {
      setEditMode(false);
      return;
    }

    const result = onSave(inputValue);
    if (result) {
      setEditMode(false);
    }
  };

  return editMode ? (
    <input
      aria-label={t('common.name')}
      type="text"
      defaultValue={value}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onChange(e);
        }
      }}
      onBlur={(e) => {
        onChange(e);
      }}
    />
  ) : (
    <DisplayableValue value={value} type="text" onClick={handleDisplayClick} />
  );
};

export default TextField;
